import { FunctionComponent } from 'react';

import CallLog from '@Containers/Report/CallLog';

import AdminCallLogProps from './AdminCallLog.types';

const AdminCallLog: FunctionComponent<AdminCallLogProps> = (
  props: AdminCallLogProps
): JSX.Element => <CallLog isAdmin {...props} />;

export default AdminCallLog;
